"use strict";
/**
 * Created by Jonas Wålekvist on 2019-11-15.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIEvent = void 0;
var APIEvent;
(function (APIEvent) {
    APIEvent["REPLAY_END"] = "replayEnd";
    APIEvent["DESTROY_RENDERER"] = "detroyRenderer";
    APIEvent["RE_INIT_RENDERER"] = "reInitRenderer";
    APIEvent["RE_INIT_RENDERER_DONE"] = "reInitRendererDone";
    APIEvent["DIALOG"] = "dialog";
    APIEvent["REALITY_CHECK"] = "realityCheck";
    APIEvent["MINIMUM_SPIN_TIME"] = "minSpinTime";
    APIEvent["PENDING_WIN"] = "pendingWin";
    APIEvent["BET"] = "bet";
    APIEvent["BALANCE"] = "balance";
    APIEvent["BET_BOOST"] = "betBoost";
    APIEvent["BROKE"] = "broke";
    APIEvent["SET_BALANCE_ID"] = "setBalanceId";
    APIEvent["BUSY"] = "busy";
    APIEvent["IDLE"] = "idle";
    APIEvent["CURRENCY"] = "currency";
    APIEvent["MESSAGES"] = "messages";
    APIEvent["WIN"] = "win";
    APIEvent["GUI_REFRESH"] = "guiRefresh";
    APIEvent["REFRESH"] = "refresh";
    APIEvent["TICK"] = "tick";
    APIEvent["UPDATE_FREE_SPINS"] = "updateFreeSpins";
    APIEvent["IS_OPEN_GAME_ROUND"] = "isOpenGameRound";
    APIEvent["FREE_BETS"] = "freeBets";
    APIEvent["FREE_FEATURE_BETS"] = "featureBets";
    APIEvent["STATE"] = "state";
    APIEvent["AUTO_PLAY"] = "autoplay";
    APIEvent["CONFIG"] = "config";
    APIEvent["CURRENT_BET"] = "currentBet";
    APIEvent["FAST_SPIN"] = "fastspin";
    APIEvent["FEATURE_BET_LEVELS"] = "featureBetLevels";
    APIEvent["ALLOWED_GAME_FEATURES"] = "allowedGameFeatures";
    APIEvent["GAME_INFO"] = "gameInfo";
    APIEvent["GAME_CLIENT_CONFIGURATION"] = "gameClientConfiguration";
    APIEvent["GAME_CLIENT_CONFIGURATION_APPLIED"] = "gameClientConfigurationApplied";
    APIEvent["INIT"] = "init";
    APIEvent["GAME"] = "game";
    APIEvent["READY"] = "ready";
    APIEvent["START"] = "start";
    //FROM CLIENT OR KEYPAD (keypad only stop and skip)
    APIEvent["STARTED"] = "started";
    APIEvent["STOP"] = "stop";
    APIEvent["SKIPPABLE"] = "skippable";
    APIEvent["FINISHING"] = "finishing";
    APIEvent["DONE"] = "done";
    APIEvent["FINISH"] = "finish";
    APIEvent["SKIP"] = "skip";
    APIEvent["SCREEN"] = "screen";
    APIEvent["GAMBLE"] = "gamble";
    APIEvent["GAMBLING"] = "gambling";
    APIEvent["GAMBLE_DONE"] = "gambleDone";
    APIEvent["REMAINING_FREE_SPINS"] = "remainingFreeSpins";
    APIEvent["JACKPOT"] = "jackpot";
    APIEvent["HOLD"] = "hold";
    APIEvent["PAUSE"] = "pause";
    APIEvent["RESUME"] = "resume";
    APIEvent["HIDDEN"] = "hidden";
    APIEvent["HALT"] = "halt";
    APIEvent["MUSIC"] = "music";
    APIEvent["SFX"] = "sfx";
    // Additional setting events
    APIEvent["SETTING_CHANGE"] = "settingChange";
    APIEvent["SETTING_PAGE_CHANGE"] = "settingPageChange";
    APIEvent["AUDIO_MASTER_MUTED"] = "soundMaster";
    APIEvent["SOFT_RESET"] = "softReset";
    APIEvent["FREEZE"] = "freeze";
    APIEvent["UNFREEZE"] = "unfreeze";
    APIEvent["ACTION_SPINS_BET"] = "actionSpinsBet";
    APIEvent["ACTION_SPINS_ROUND_COMPLETE"] = "actionSpinsRoundComplete";
    APIEvent["ACTION_SPINS_IS_ACTIVE"] = "actionSpinsActive";
    APIEvent["REPLAY_BASE_URL"] = "replayBaseUrl";
    APIEvent["SERVER_VERSION"] = "serverVersion";
})(APIEvent = exports.APIEvent || (exports.APIEvent = {}));
//# sourceMappingURL=APIEventSystem.js.map